import { Pill, type PillVariant } from "@/components/ui/Pill";
import { Tooltip } from "@/components/ui/Tooltip";
import { runStatusLabel } from "@/lib/strings";
import { truncate } from "@/lib/utils";
import type { RunStatus } from "@/types/fleet";

const VARIANT: Record<RunStatus, PillVariant> = {
  QUEUED: "neutral",
  WAITING_UNLOCK: "warn",
  RUNNING: "info",
  SUCCESS: "success",
  FAILED: "danger",
  SKIPPED: "muted",
  CANCELLED: "muted",
};

export function RunStatusPill({
  status,
  error,
  size = "md",
}: {
  status: RunStatus;
  /** Shown in the tooltip for FAILED — the code alone is rarely enough. */
  error?: string | null;
  size?: "sm" | "md";
}) {
  const pill = (
    <Pill variant={VARIANT[status]} size={size} className="relative">
      {status === "RUNNING" && (
        <span className="absolute -ml-1.5 size-1.5 animate-ping rounded-full bg-current opacity-60" />
      )}
      {runStatusLabel(status)}
    </Pill>
  );

  if (status === "FAILED" && error) {
    return <Tooltip content={<span className="font-mono">{truncate(error, 240)}</span>}>{pill}</Tooltip>;
  }
  return pill;
}
